/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import OtpInput from "react-otp-input";
import * as S from "../../styles";

export interface IOTPInputCompProps {
    id: string;
    label?: string;
    numInputs?: number;
    separator?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    required?: boolean;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const OTPInputComp = ({
    id,
    label,
    labelColor,
    errorText,
    value,
    required,
    numInputs,
    separator,
    onCompChange,
    hasError
}: IOTPInputCompProps) => {
    const [textValue, setTextValue] = useState(value ?? "");
    const onChange = (id: string, e: any) => {
        setTextValue(e);
        onCompChange && onCompChange(id, e);
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className="mb-4 formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <OtpInput
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        numInputs={numInputs}
                        separator={<span>{separator}</span>}
                        containerStyle={{ width: "100%" }}
                    />
                </InputGroup>
                <InputGroup>{_renderErrorTextIf()}</InputGroup>
            </Form.Group>
        </>
    );
};

OTPInputComp.defaultProps = {
    required: false,
    hasError: false,
    numInputs: 6,
    separator: "-"
};
